import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import {
    combineClasses,
} from 'wanderu-css';

import TableContext from '../Table/TableContext';

import styles from './TableRow.scss';

function TableRow(props) {
    const {
        classes: classesProps = {},
        className,
        component: ComponentProp = 'tr',
        componentProps,
        variant = 'body',
        ...otherProps
    } = props;

    const { variant: variantContext, orientation } = React.useContext(TableContext);
    const classes = combineClasses(styles, classesProps);

    return (
        <ComponentProp
            className={clsx(
                classes.root,
                classes[variantContext],
                { [classes.shadedBody]: variant === 'body' && variantContext === 'blocks' },
                classes[orientation],
                className,
            )}
            {...componentProps}
            {...otherProps}
        />
    );
}

TableRow.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    component: PropTypes.elementType,
    componentProps: PropTypes.object,
    variant: PropTypes.oneOf(['body', 'head']),
};

export default TableRow;
